module.exports = __webpack_public_path__ + "img/9_97.92f5846a.png";